// Trimmed so ids stored/queried with stray whitespace (e.g. a leading TAB) still
// match the exact keap_partner_id filter on the server.
export const normalizeKeapPartnerId = id => {
  if (id === null || id === undefined) return ''
  return String(id).trim()
}

// One id precedence for both writing a partner link and listing links/orders, so
// a link is always listed under the id it was saved with.
//   InfluencerOps: networkId (their all-partner view is gated by role on the server)
//   otherwise:     overrides (first non-empty, write path only) > id kept in the
//                  session store > Auth0 user_metadata.keapPartnerId
export const resolveKeapPartnerId = ({
  isInfluencerOps = false,
  overrides = [],
  storedKeapPartnerId,
  user,
} = {}) => {
  const metadata = user?.user_metadata
  const candidates = isInfluencerOps
    ? [metadata?.networkId]
    : [...overrides, storedKeapPartnerId, metadata?.keapPartnerId]
  return candidates.map(normalizeKeapPartnerId).find(Boolean) || undefined
}
